import Vue from 'vue'
import Tooltip from 'vue-directive-tooltip'
// import 'vue-directive-tooltip/dist/vueDirectiveTooltip.css'

Vue.use(Tooltip, {
  class: 'vue-tooltip',
  placement: 'top'
})
